import { forwardRef } from 'react';
import { Box } from '../../Box';
import { jsx as _jsx } from "react/jsx-runtime";
const _bottom = theme => ({
  borderLeft: `1px solid ${theme.tokens.ComponentPopoverBorderColor}`,
  borderTop: `1px solid ${theme.tokens.ComponentPopoverBorderColor}`,
  left: '50%',
  transform: 'translateX(-50%) rotate(45deg)',
  top: '-6px'
});
const _top = theme => ({
  borderRight: `1px solid ${theme.tokens.ComponentPopoverBorderColor}`,
  borderBottom: `1px solid ${theme.tokens.ComponentPopoverBorderColor}`,
  left: '50%',
  transform: 'translateX(-50%) rotate(45deg)',
  bottom: '-6px'
});
const _left = theme => ({
  borderTop: `1px solid ${theme.tokens.ComponentPopoverBorderColor}`,
  borderRight: `1px solid ${theme.tokens.ComponentPopoverBorderColor}`,
  top: '50%',
  transform: 'translateY(-50%) rotate(45deg)',
  right: '-6px'
});
const _right = theme => ({
  borderBottom: `1px solid ${theme.tokens.ComponentPopoverBorderColor}`,
  borderLeft: `1px solid ${theme.tokens.ComponentPopoverBorderColor}`,
  top: '50%',
  transform: 'translateY(-50%) rotate(45deg)',
  left: '-6px'
});
const _bottomEnd = theme => ({
  borderBottom: `1px solid ${theme.tokens.ComponentPopoverBorderColor}`,
  borderLeft: `1px solid ${theme.tokens.ComponentPopoverBorderColor}`,
  right: '20px',
  transform: 'translateY(-50%) rotate(133deg)',
  top: 0
});
const _bottomStart = theme => ({
  borderBottom: `1px solid ${theme.tokens.ComponentPopoverBorderColor}`,
  borderLeft: `1px solid ${theme.tokens.ComponentPopoverBorderColor}`,
  left: '20px',
  transform: 'translateY(-50%) rotate(133deg)',
  top: 0
});
const _topStart = theme => ({
  borderRight: `1px solid ${theme.tokens.ComponentPopoverBorderColor}`,
  borderBottom: `1px solid ${theme.tokens.ComponentPopoverBorderColor}`,
  left: '25px',
  transform: 'translateX(-50%) rotate(45deg)',
  bottom: '-6px'
});
const _topEnd = theme => ({
  borderRight: `1px solid ${theme.tokens.ComponentPopoverBorderColor}`,
  borderBottom: `1px solid ${theme.tokens.ComponentPopoverBorderColor}`,
  right: '15px',
  transform: 'translateX(-50%) rotate(45deg)',
  bottom: '-6px'
});
const _leftStart = theme => ({
  borderTop: `1px solid ${theme.tokens.ComponentPopoverBorderColor}`,
  borderRight: `1px solid ${theme.tokens.ComponentPopoverBorderColor}`,
  top: '24px',
  transform: 'translateY(-50%) rotate(45deg)',
  right: '-6px'
});
const _leftEnd = theme => ({
  borderTop: `1px solid ${theme.tokens.ComponentPopoverBorderColor}`,
  borderRight: `1px solid ${theme.tokens.ComponentPopoverBorderColor}`,
  bottom: '16px',
  transform: 'translateY(-50%) rotate(45deg)',
  right: '-6px'
});
const _rightEnd = theme => ({
  borderTop: `1px solid ${theme.tokens.ComponentPopoverBorderColor}`,
  borderRight: `1px solid ${theme.tokens.ComponentPopoverBorderColor}`,
  bottom: '16px',
  transform: 'translateY(-50%) rotate(225deg)',
  left: '-6px'
});
const _rightStart = theme => ({
  borderTop: `1px solid ${theme.tokens.ComponentPopoverBorderColor}`,
  borderRight: `1px solid ${theme.tokens.ComponentPopoverBorderColor}`,
  top: '24px',
  transform: 'translateY(-50%) rotate(225deg)',
  left: '-6px'
});
const _default = theme => ({
  borderLeft: `1px solid ${theme.tokens.ComponentPopoverBorderColor}`,
  borderTop: `1px solid ${theme.tokens.ComponentPopoverBorderColor}`,
  left: '50%',
  transform: 'translateX(-50%) rotate(45deg)',
  top: '-6px'
});
const _resolvePlacement = (placement, theme) => {
  switch (placement) {
    case 'bottom':
      {
        return _bottom(theme);
      }
    case 'top':
      {
        return _top(theme);
      }
    case 'left':
      {
        return _left(theme);
      }
    case 'right':
      {
        return _right(theme);
      }
    case 'bottom-end':
      {
        return _bottomEnd(theme);
      }
    case 'bottom-start':
      {
        return _bottomStart(theme);
      }
    case 'top-start':
      {
        return _topStart(theme);
      }
    case 'top-end':
      {
        return _topEnd(theme);
      }
    case 'left-start':
      {
        return _leftStart(theme);
      }
    case 'left-end':
      {
        return _leftEnd(theme);
      }
    case 'right-end':
      {
        return _rightEnd(theme);
      }
    case 'right-start':
      {
        return _rightStart(theme);
      }
    default:
      return _default(theme);
  }
};
const _styledPopoverArrow = (theme, placement, variant) => {
  const _base = {
    margin: 'auto',
    width: '3em',
    height: '3em',
    background: theme.tokens.ComponentPopoverBg,
    visibility: 'visible',
    content: '""',
    display: variant === 'pointerless' ? 'none' : 'block',
    position: 'fixed'
  };
  return {
    position: 'absolute',
    fontSize: '4px',
    '&:before': {
      ..._base,
      ..._resolvePlacement(placement, theme)
    },
    '& > div': {
      ..._base,
      ..._resolvePlacement(placement, theme),
      boxShadow: theme.tokens.BaseShadowMd,
      zIndex: '-1'
    }
  };
};
export const PopoverArrow = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    theme,
    variant,
    context
  } = _ref;
  return /*#__PURE__*/_jsx(Box, {
    component: 'div',
    sx: _styledPopoverArrow(theme, context.placement, variant),
    className: 'ids-popover-arrow',
    id: 'ids-popover-arrow-id',
    "data-testid": 'ids-popover-arrow-data-test-id',
    children: /*#__PURE__*/_jsx(Box, {
      component: 'div'
    })
  });
});
PopoverArrow.displayName = 'PopoverArrow';